import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { IconStarter, IconBusiness, IconProfessional, IconPremium } from './PlanIcons'
import AuditModal from './AuditModal'

const IconTrue = `<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.0002 15.172L19.1922 5.979L20.6072 7.393L10.0002 18L3.63623 11.636L5.05023 10.222L10.0002 15.172Z" fill="#57007B"/></svg>`

const plansData = {
    "INR": [
        { name: 'STARTER', icon: IconStarter, price: '₹39,000', extraLabel: 'Add. Per Page', extraCost: '₹3,600' },
        { name: 'BUSINESS', icon: IconBusiness, price: '₹63,000', extraLabel: 'Add. Per Page', extraCost: '₹4,500' },
        { name: 'PROFESSIONAL', icon: IconProfessional, price: '₹84,000', extraLabel: 'Add. Per Page', extraCost: '₹5,400', popular: true },
        { name: 'PREMIUM', icon: IconPremium, price: '₹1,09,000', extraLabel: 'Add. Per Page', extraCost: '₹6,300' },
    ],
    "USD": [
        { name: 'STARTER', icon: IconStarter, price: '$565', extraLabel: 'Add. Per Page', extraCost: '$52' },
        { name: 'BUSINESS', icon: IconBusiness, price: '$913', extraLabel: 'Add. Per Page', extraCost: '$65' },
        { name: 'PROFESSIONAL', icon: IconProfessional, price: '$1,217', extraLabel: 'Add. Per Page', extraCost: '$78', popular: true },
        { name: 'PREMIUM', icon: IconPremium, price: '$1,565', extraLabel: 'Add. Per Page', extraCost: '$91' },
    ]
}

const tableData = [
    { titleText: 'Bespoke design – from scratch', col1: IconTrue, col2: IconTrue, col3: IconTrue, col4: IconTrue },
    { titleText: '<a target="_blank" rel="noreferrer" href="https://wordpress.org/plugins/">Any Extension / Plugin / Application</a>', col1: 'Add-on', col2: 'Add-on', col3: 'Add-on', col4: 'Add-on' },
    { titleText: 'Webpages Development', col1: '5', col2: '7', col3: '9', col4: '11' },
    { titleText: 'Conceptual &amp; Best Look – Up To Layouts<br><b>Additional Per Layout Cost ₹9,000</b>', col1: '1', col2: '2', col3: '3', col4: '4' },
    { titleText: 'Homepage Sections', col1: '3', col2: '6', col3: '9', col4: '12' },
    { titleText: 'Content Writing', col1: '1', col2: '2', col3: '3', col4: '4' },
    { titleText: 'Homepage Banners (qty)', col1: '2', col2: '3', col3: 'Video', col4: 'Video' },
    { titleText: 'Banners For Inner Pages', col1: 'Home', col2: 'Home', col3: 'All', col4: 'All' },
    { titleText: 'Pages Mobile Banners', col1: 'Home', col2: 'Home', col3: 'All', col4: 'All' },
    { titleText: 'Revisions – Graphic + HTML', col1: '1', col2: '1', col3: '2', col4: '3' },
    { titleText: 'Image Editing<br>Watermarking (If Required)', col1: '10', col2: '15', col3: '20', col4: '25' },
    { titleText: 'Competitors Meta Analysis', col1: '-', col2: '-', col3: '3', col4: '6' },
    { titleText: 'Responsive Web – Mobile &amp; Tablet Support', col1: '70%', col2: '80%', col3: '95%', col4: '100%' },
    { titleText: 'Team Level', col1: 'Skilled', col2: 'Pro', col3: 'Pro', col4: 'Expert' },
    { titleText: 'Manually Testing', col1: 'Chrome', col2: 'Firefox<br>Chrome', col3: 'Edge<br>Firefox<br>Chrome', col4: 'Safari<br>Edge<br>Firefox<br>Chrome' },
    { titleText: 'Blog / News / Events / Updates', col1: '-', col2: '-', col3: '-', col4: IconTrue },
    { titleText: 'Blog Writing<br><small>(Free complimentary blogs, per website once in a month)</small>', col1: '-', col2: '-', col3: '-', col4: IconTrue },
    { titleText: 'Old Web URL Optimization', col1: '-', col2: '-', col3: '-', col4: IconTrue },
    { titleText: 'Google PageSpeed Insights', col1: '-', col2: '-', col3: '-', col4: IconTrue },
    { titleText: 'Search Form', col1: '-', col2: '-', col3: '-', col4: IconTrue },
    { titleText: 'SEO Basic Package Included', col1: '-', col2: '-', col3: IconTrue, col4: IconTrue },
    { titleText: 'WWW – One URL For SEO', col1: '-', col2: '-', col3: IconTrue, col4: IconTrue },
    { titleText: 'Mega Menu Setup', col1: '-', col2: '-', col3: IconTrue, col4: IconTrue },
    { titleText: 'Google Language Translator', col1: '-', col2: '-', col3: IconTrue, col4: IconTrue },
    { titleText: 'Email Response Of The Inquiry', col1: '-', col2: '-', col3: IconTrue, col4: IconTrue },
    { titleText: 'CTA (Call To Action)', col1: '-', col2: '-', col3: IconTrue, col4: IconTrue },
    { titleText: '404 Error Optimization', col1: '-', col2: '-', col3: IconTrue, col4: IconTrue },
    { titleText: 'SSL Certificate Installation', col1: '-', col2: IconTrue, col3: IconTrue, col4: IconTrue },
    { titleText: 'CSS Animation', col1: '-', col2: IconTrue, col3: IconTrue, col4: IconTrue },
    { titleText: 'Non Broken Link', col1: '-', col2: IconTrue, col3: IconTrue, col4: IconTrue },
    { titleText: 'Image Optimization', col1: '-', col2: IconTrue, col3: IconTrue, col4: IconTrue },
    { titleText: 'Footer Menu', col1: '-', col2: IconTrue, col3: IconTrue, col4: IconTrue },
    { titleText: 'Enquiry Form &amp; Thank You Page<br>Count a Separate Page<br>MX, SPF, DKIM &amp; DMARC Setup<br><small>(One business email also required)</small>', col1: '-', col2: IconTrue, col3: IconTrue, col4: IconTrue },
    { titleText: 'Google Analytics Setup', col1: IconTrue, col2: IconTrue, col3: IconTrue, col4: IconTrue },
    { titleText: 'Social Media Networking Linking', col1: IconTrue, col2: IconTrue, col3: IconTrue, col4: IconTrue },
    { titleText: 'Sticky Header Menu', col1: IconTrue, col2: IconTrue, col3: IconTrue, col4: IconTrue },
    { titleText: 'WhatsApp Share', col1: IconTrue, col2: IconTrue, col3: IconTrue, col4: IconTrue },
    { titleText: 'Favicon Icon', col1: IconTrue, col2: IconTrue, col3: IconTrue, col4: IconTrue },
    { titleText: 'Finding Free Images Related To Contents', col1: IconTrue, col2: IconTrue, col3: IconTrue, col4: IconTrue },
    { titleText: 'Server Upload', col1: IconTrue, col2: IconTrue, col3: IconTrue, col4: IconTrue },
    { titleText: 'Testing / Quality Check', col1: IconTrue, col2: IconTrue, col3: IconTrue, col4: IconTrue },
]

export default function CmsWebPlanTable() {
    const [currency, setCurrency] = useState('INR');
    const [showAuditModal, setShowAuditModal] = useState(false);

    const plans = plansData[currency];

    return (
        <div className="pricing-new cSection">
            <div className="cContainer">
                {/* Currency Toggle */}
                <div className="pricing-currency-select">
                    <div className="currency-toggle">
                        <button className={currency === 'INR' ? 'active' : ''} onClick={() => setCurrency('INR')}>₹INR</button>
                        <button className={currency === 'USD' ? 'active' : ''} onClick={() => setCurrency('USD')}>$USD</button>
                    </div>
                </div>

                <div className="pricing-unified-wrapper">
                    <table className="pricing-unified-table">
                        <thead>
                            <tr>
                                <th className="features-header">
                                    <h3>Our Plans</h3>
                                    <p>Select the best plan for your needs.</p>
                                </th>
                                {plans.map((plan, idx) => (
                                    <th className={`plan-header ${plan.popular ? 'popular' : ''}`} key={idx}>
                                        <div className="plan-header-content">
                                            {plan.popular && <span className="popular-badge">Popular</span>}
                                            {plan.icon && <div className="plan-icon" dangerouslySetInnerHTML={{ __html: plan.icon }}></div>}
                                            <span className="plan-name">{plan.name}</span>
                                            <div className="plan-price" dangerouslySetInnerHTML={{ __html: plan.price }}></div>
                                            {plan.originalPrice && <div className="plan-price-original">{plan.originalPrice}</div>}
                                            {!plan.originalPrice && <div className="plan-price-original"></div>}
                                            <span className="plan-type">One-time cost</span>
                                            {plan.extraCost && <span className="plan-extra">{plan.extraLabel}: {plan.extraCost}</span>}
                                            <button className="plan-cta" onClick={() => setShowAuditModal(true)}>Get Started</button>
                                        </div>
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {tableData.map((row, idx) => (
                                <tr key={idx}>
                                    <td dangerouslySetInnerHTML={{ __html: row.titleText }}></td>
                                    <td className={plans[0]?.popular ? 'popular-cell' : ''}><span className="check-icon" dangerouslySetInnerHTML={{ __html: row.col1 }}></span></td>
                                    <td className={plans[1]?.popular ? 'popular-cell' : ''}><span className="check-icon" dangerouslySetInnerHTML={{ __html: row.col2 }}></span></td>
                                    <td className={plans[2]?.popular ? 'popular-cell' : ''}><span className="check-icon" dangerouslySetInnerHTML={{ __html: row.col3 }}></span></td>
                                    <td className={plans[3]?.popular ? 'popular-cell' : ''}><span className="check-icon" dangerouslySetInnerHTML={{ __html: row.col4 }}></span></td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                <AuditModal show={showAuditModal} handleClose={() => setShowAuditModal(false)} />

                {/* Notes */}
                <div className="pricing-notes">
                    <h4 className="notes-title">Note:-</h4>
                    <ul className="notes-list">
                        <li>The client should provide clear photographs, videos, and content.</li>
                        <li>Once the material is uploaded to the website, any changes will be chargeable afterward.</li>
                        <li>18% GST Tax extra (for Indian customers only).</li>
                        <li>Payment Gateway + Forex cost extra (for international customers only).</li>
                        <li>Domain &amp; Hosting cost is extra (not included in the above pricing).</li>
                        <li>WordPress theme license cost is extra if a premium theme is selected.</li>
                        <li>Advance charges apply to plugin recommendations (Charges are non-refundable).</li>
                        <li>If there are any complications with any plugin, additional charges will apply.</li>
                        <li>Any additional page or section beyond the plan scope will be charged separately as per the Additional Per Page Cost.</li>
                        <li>Content Writing is limited to the pages mentioned in the plan; extra pages are chargeable.</li>
                        <li>One business email is required for MX, SPF, DKIM &amp; DMARC setup (not included).</li>
                    </ul>
                </div>
            </div>
        </div>
    )
}
